module.exports = __webpack_public_path__ + "media/images/renegade-a30e2dcec5ed6353adcf96ba4edcb18f.png";